import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section
      id="hero"
      className="relative flex min-h-screen w-full items-center justify-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/08b57743-7d7c-4a2a-9051-d88c4793a586_compressed_1.webp')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-28 text-center md:px-6">
        <p className="reveal mb-6 text-xs uppercase tracking-[0.4em] text-primary-400 md:text-sm">
          {t('brand.tagline')}
        </p>

        <h1 className="reveal reveal-delay-1 font-heading text-4xl leading-tight text-background-50 md:text-6xl lg:text-7xl">
          <span className="block">{t('hero.title1')}</span>
          <span className="block text-primary-500">{t('hero.title2')}</span>
        </h1>

        <p className="reveal reveal-delay-2 mt-6 max-w-2xl text-base leading-relaxed text-background-100/85 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="reveal reveal-delay-3 mt-10 flex flex-col items-center gap-4 sm:flex-row">
          <a
            href="#iletisim"
            className="whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
          >
            {t('hero.cta1')}
          </a>
          <a
            href="#garaj"
            className="whitespace-nowrap rounded-md border border-background-100/50 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:border-primary-500 hover:text-primary-400"
          >
            {t('hero.cta2')}
          </a>
        </div>

        <p className="reveal reveal-delay-3 mt-10 text-xs tracking-widest text-background-100/60 md:text-sm">
          {t('hero.small')}
        </p>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2">
        <a href="#garaj" aria-label="Scroll down" className="text-background-100/60">
          <i className="ri-arrow-down-line text-2xl" aria-hidden="true"></i>
        </a>
      </div>
    </section>
  );
}